<template>
  <Modal
    :visible="visible"
    :footer="null"
    :destroyOnClose="true"
    wrap-class-name="empty-modal"
    @cancel="visible = false"
    width="1000px"
  >
    <div>
      <iframe
        :src="`${apiUrl}/custom-email-campaign/view/program?program_id=${campaignId}&token=${token}`"
        frameborder="0"
        width="100%"
        style="min-height: 75vh"
        title="preview email"
      ></iframe>
    </div>
  </Modal>
  <Modal
    :visible="scheduleModalVisible"
    title="Confirm campaign schedule"
    :destroyOnClose="true"
    @cancel="scheduleModalVisible = false"
    width="600px"
  >
    <div v-if="schedulePreview">
      <p class="mb-3">
        {{ schedulePreview.total }} recipients will be emailed in
        {{ schedulePreview.batches.length }}
        {{ schedulePreview.batches.length === 1 ? 'batch' : 'batches' }} of up to
        {{ schedulePreview.batch_size }}, one batch every {{ schedulePreview.interval_minutes }}
        minutes. Times are in Mountain Time (America/Denver).
      </p>
      <p v-if="campaignViewData?.records?.length" class="mb-3 text-yellow-600">
        Saving replaces the campaign's current schedule.
      </p>
      <Table
        :data-source="schedulePreview.batches"
        :columns="scheduleColumns"
        :pagination="false"
        :scroll="{ y: 400 }"
        row-key="index"
        size="small"
      />
    </div>
    <template #footer>
      <Button @click="scheduleModalVisible = false">Cancel</Button>
      <Button type="primary" :loading="loading" @click="saveSchedule">Save schedule</Button>
    </template>
  </Modal>
  <div class="account-page py-4 mt-4">
    <div class="container">
      <div class="w-full main-card px-3 md:px-4 lg:px-5 py-4 lg:py-5 xl:py-7">
        <h1 class="text-center">Campaign #{{ campaignViewData?.name ?? '' }}</h1>
        <div class="text-right flex gap-2">
          <Button
            type="primary"
            size="small"
            class="rounded shadow flex items-center gap-2 p-4 bg-success-600 border-0"
            @click="visible = true"
          >
            Edit Campaign Email
          </Button>
          <Button
            type="secondary"
            size="small"
            class="rounded shadow flex items-center gap-2 p-4 bg-success-600 border-0"
            @click="sendSample(campaignViewData?._id)"

            :loading="loading"
          >
            Send sample
          </Button>
        </div>
        <Tabs v-model:activeKey="activeKey" class="w-full">
          <TabPane key="1" tab="Campaign Schulded Dates">
            <div class="flex flex-row justify-content-between align-center">
              <h1 class="d-block">Date Scheduling</h1>
            </div>
            <p class="text-gray-600">
              Pick when the first emails go out. Emails are sent in batches of up to 1,500, one
              batch every 90 minutes.
            </p>
            <Row class="my-2 gap-1">
              <Col span="11" class="m-auto">
                <DatePicker
                  format="YYYY-MM-DD"
                  value-format="YYYY-MM-DD"
                  class="w-full"
                  v-model:value="when_to_send_date"
                  :disabled="isLocked"
                />
              </Col>
              <Col span="11" class="m-auto">
                <TimePicker
                  format="HH:mm"
                  class="w-full"
                  v-model:value="am8"
                  value-format="HH:mm"
                  :disabled="isLocked"
                />
              </Col>
            </Row>
            <p v-if="isLocked" class="text-yellow-600">
              This campaign has already started sending and can no longer be rescheduled.
            </p>
            <Button
              class="block mt-3 mb-10"
              htmlType="submit"
              block
              type="primary"
              :loading="loading"
              :disabled="isLocked"
              @click="previewSchedule"
            >
              <div class="flex items-center justify-center gap-2" @loading="loading">
                Preview schedule
              </div>
            </Button>
            <ScheduledDates />
          </TabPane>
          <TabPane key="2" tab="Emails List">
            <div v-if="campaignViewData" class="bg-white rounded-lg shadow-md">
              <ul class="space-y-2">
                <li
                  v-for="(email, index) in campaignViewData.emails"
                  :key="index"
                  class="flex items-center p-3 bg-gray-50 rounded-md hover:bg-gray-100 transition-colors"
                >
                  <svg
                    class="w-5 h-5 text-gray-400 mr-3"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                    />
                  </svg>
                  <span class="text-gray-700">{{ email }}</span>
                </li>
              </ul>
            </div>
            <div v-else class="flex items-center justify-center p-12">
              <div class="text-center">
                <svg
                  class="animate-spin h-10 w-10 text-blue-600 mx-auto mb-4"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <circle
                    class="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    stroke-width="4"
                  ></circle>
                  <path
                    class="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                  ></path>
                </svg>
                <p class="text-gray-600 text-lg">Loading campaign details...</p>
              </div>
            </div>
          </TabPane>
        </Tabs>
      </div>
    </div>
  </div>
</template>
<script>
/* eslint-disable */
import campaignsApi from '@/services/apis/admin/campaigns.api';
import { ADMIN_OLD_CAMPAIGNS } from '@/store/types';
import {
  Button,
  Col,
  DatePicker,
  message,
  Modal,
  Row,
  Table,
  TabPane,
  Tabs,
  TimePicker,
} from 'ant-design-vue';
import ScheduledDates from './ScheduledDates.vue';
import { getAdminToken } from '@/services/jwt.service';
import handleResErrors from '@/utils/handleResErrors';

export default {
  components: {
    Tabs,
    TabPane,
    Col,
    Row,
    TimePicker,
    DatePicker,
    Button,
    ScheduledDates,
    Modal,
    Table,
  },
  async mounted() {
    this.$store.commit(
      ADMIN_OLD_CAMPAIGNS.SET_CAMPAIGN_VIEW_DATA,
      await campaignsApi.getCampaignById({ id: this.campaignId }),
    );
  },
  data() {
    return {
      campaign_name: null,
      file_content: null,
      am8: '08:00',
      loading: false,
      campaignId: this.$route.params.id,
      activeKey: '1',
      when_to_send_date: null,
      visible: false,
      token: null,
      scheduleModalVisible: false,
      // preview returned by the backend, plus the start_at it was computed for
      schedulePreview: null,
      scheduleColumns: [
        { title: 'Batch', dataIndex: 'index', key: 'index', width: 80 },
        { title: 'Send at', dataIndex: 'scheduled_at', key: 'scheduled_at' },
        { title: 'Recipients', dataIndex: 'count', key: 'count' },
      ],
    };
  },
  created() {
    this.token = getAdminToken();
  },
  computed: {
    apiUrl() {
      return process.env.VUE_APP_API || 'https://dev.api.commutrics.com/api';
    },
    campaignViewData() {
      return this.$store.state.campaigns.campaignViewData;
    },
    isLocked() {
      return !!this.campaignViewData?.locked;
    },
  },
  methods: {
    async previewSchedule() {
      if (!this.when_to_send_date) {
        message.error('Please select a scheduling date.');
        return;
      }
      if (!this.am8) {
        message.error('Please select a scheduling time.');
        return;
      }
      // Check if date in the past
      const selectedDateTime = new Date(`${this.when_to_send_date}T${this.am8}:00`);
      const now = new Date();
      if (selectedDateTime <= now) {
        message.error('The selected date and time must be in the future.');
        return;
      }
      const startAt = `${this.when_to_send_date} ${this.am8}`;

      this.loading = true;
      try {
        const preview = await campaignsApi.previewCampaignSchedule({
          campaignId: this.campaignId,
          startAt,
        });
        this.schedulePreview = { ...preview, startAt };
        this.scheduleModalVisible = true;
      } catch (error) {
        message.error(handleResErrors(error, 'Failed to preview the campaign schedule.'), 10);
      } finally {
        this.loading = false;
      }
    },
    async saveSchedule() {
      this.loading = true;
      try {
        // save exactly what the admin saw in the preview
        await campaignsApi.scheduleCampaign({
          campaignId: this.campaignId,
          startAt: this.schedulePreview.startAt,
        });
        message.success('Campaign scheduled successfully!');
        this.scheduleModalVisible = false;
        this.schedulePreview = null;
        this.when_to_send_date = null;
        this.am8 = '08:00';
        this.$store.commit(
          ADMIN_OLD_CAMPAIGNS.SET_CAMPAIGN_VIEW_DATA,
          await campaignsApi.getCampaignById({ id: this.campaignId }),
        );
      } catch (error) {
        message.error(handleResErrors(error, 'Failed to schedule the campaign.'), 10);
      } finally {
        this.loading = false;
      }
    },
    async sendSample(id) {
      this.loading = true;
      try {
        await campaignsApi.sendSample({ id });
        message.success('Sample email sent.');
      } catch (error) {
        message.error(handleResErrors(error, 'Failed to send the sample email.'), 10);
      } finally {
        this.loading = false;
      }
    }
  },
};
</script>
